
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5XkWH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4562b5d23184c324$export$2e2bcd8739ae039; });

var $72NmR = parcelRequire("72NmR");

var $cJhvT = parcelRequire("cJhvT");

var $iSvIT = parcelRequire("iSvIT");

var $lL4Ma = parcelRequire("lL4Ma");

var $fS4A7 = parcelRequire("fS4A7");

var $eTo1d = parcelRequire("eTo1d");

var $12ZPF = parcelRequire("12ZPF");

var $MIq2I = parcelRequire("MIq2I");

var $kMg75 = parcelRequire("kMg75");
var $4562b5d23184c324$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $4562b5d23184c324$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $4562b5d23184c324$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, $cJhvT.default)(_ref, $4562b5d23184c324$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $cJhvT.default)(unsafeRest, $4562b5d23184c324$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $12ZPF.default), (0, $72NmR.default)({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === "circle",
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $MIq2I.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $kMg75.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eTo1d.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $fS4A7.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $12ZPF.default), (0, $72NmR.default)({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === "circle",
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $lL4Ma.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $MIq2I.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $kMg75.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eTo1d.default), null, label)));
    });
}));
$4562b5d23184c324$var$IconButton.displayName = "IconButton";
var $4562b5d23184c324$export$2e2bcd8739ae039 = $4562b5d23184c324$var$IconButton;

});
parcelRegister("12ZPF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c35f0f595d2f583$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $72NmR = parcelRequire("72NmR");

var $cJhvT = parcelRequire("cJhvT");

var $8fP1t = parcelRequire("8fP1t");

var $iSvIT = parcelRequire("iSvIT");

var $gmylQ = parcelRequire("gmylQ");

var $lL4Ma = parcelRequire("lL4Ma");

var $dyf9a = parcelRequire("dyf9a");

var $dWwnB = parcelRequire("dWwnB");

var $jxLBU = parcelRequire("jxLBU");

var $2rRcm = parcelRequire("2rRcm");

var $eTo1d = parcelRequire("eTo1d");

var $2i2fk = parcelRequire("2i2fk");

var $9lekW = parcelRequire("9lekW");

var $5rIkq = parcelRequire("5rIkq");
var $0c35f0f595d2f583$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $0c35f0f595d2f583$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $0c35f0f595d2f583$var$LOADING_LABEL = ", Loading";
var $0c35f0f595d2f583$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk1fvb _syaz1lh4 _aetrglyw _irr31fvb _30l31lh4 _1di61fvb _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko14q2",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $0c35f0f595d2f583$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
var $0c35f0f595d2f583$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $0c35f0f595d2f583$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $0c35f0f595d2f583$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $0c35f0f595d2f583$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $0c35f0f595d2f583$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
var $0c35f0f595d2f583$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $0c35f0f595d2f583$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, $cJhvT.default)(_ref, $0c35f0f595d2f583$var$_excluded);
    var localRef = (0, $iSvIT.useRef)(null);
    var splitButtonContext = (0, $2i2fk.useSplitButtonContext)();
    var loadingLabelId = (0, $dWwnB.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = isDefaultAppearanceSplitButton && (0, $jxLBU.fg)("platform-component-visual-refresh") ? "subtle" : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || "default";
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $dyf9a.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, $cJhvT.default)(unsafeRest, $0c35f0f595d2f583$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2rRcm.default), (0, $72NmR.default)({}, saferRest, {
        componentName: componentName || "button",
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $lL4Ma.default)([
            localRef,
            ref
        ]),
        xcss: (0, $gmylQ.cx)($0c35f0f595d2f583$var$styles.base, appearance === "default" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0c35f0f595d2f583$var$defaultStyles.rootRefreshed : $0c35f0f595d2f583$var$defaultStyles.root), appearance === "default" && isInteractive && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0c35f0f595d2f583$var$defaultStyles.interactiveRefreshed : $0c35f0f595d2f583$var$defaultStyles.interactive), appearance === "primary" && $0c35f0f595d2f583$var$primaryStyles.root, appearance === "primary" && isInteractive && $0c35f0f595d2f583$var$primaryStyles.interactive, appearance === "warning" && $0c35f0f595d2f583$var$warningStyles.root, appearance === "warning" && isInteractive && $0c35f0f595d2f583$var$warningStyles.interactive, appearance === "danger" && $0c35f0f595d2f583$var$dangerStyles.root, appearance === "danger" && isInteractive && $0c35f0f595d2f583$var$dangerStyles.interactive, appearance === "discovery" && $0c35f0f595d2f583$var$discoveryStyles.root, appearance === "discovery" && isInteractive && $0c35f0f595d2f583$var$discoveryStyles.interactive, appearance === "subtle" && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0c35f0f595d2f583$var$subtleStyles.rootRefreshed : $0c35f0f595d2f583$var$subtleStyles.root), appearance === "subtle" && isInteractive && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0c35f0f595d2f583$var$subtleStyles.interactiveRefreshed : $0c35f0f595d2f583$var$subtleStyles.interactive), $0c35f0f595d2f583$var$styles.linkDecorationUnset, isSelected && ((0, $jxLBU.fg)("platform-component-visual-refresh") ? $0c35f0f595d2f583$var$selectedStyles.rootRefreshed : $0c35f0f595d2f583$var$selectedStyles.root), isSelected && isSplitButton && $0c35f0f595d2f583$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $0c35f0f595d2f583$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "danger" && $0c35f0f595d2f583$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "warning" && $0c35f0f595d2f583$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "discovery" && $0c35f0f595d2f583$var$selectedStyles.discovery, isDisabled && $0c35f0f595d2f583$var$styles.disabled, isCircle && !isSplitButton && $0c35f0f595d2f583$var$styles.circle, spacing === "compact" && $0c35f0f595d2f583$var$styles.spacingCompact, hasIconBefore && $0c35f0f595d2f583$var$styles.buttonIconBefore, shouldFitContainer && $0c35f0f595d2f583$var$styles.fullWidth, hasIconAfter && $0c35f0f595d2f583$var$styles.buttonIconAfter, isIconButton && $0c35f0f595d2f583$var$styles.iconButton, isIconButton && spacing === "compact" && $0c35f0f595d2f583$var$styles.iconButtonCompact, isLoading && $0c35f0f595d2f583$var$styles.loading, isSplitButton && $0c35f0f595d2f583$var$styles.splitButton, isNavigationSplitButton && $0c35f0f595d2f583$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($0c35f0f595d2f583$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $9lekW.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2i2fk.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        className: (0, $8fP1t.default)([
            $0c35f0f595d2f583$var$styles.loadingOverlay
        ])
    }, (0, $5rIkq.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eTo1d.default), {
        id: loadingLabelId
    }, $0c35f0f595d2f583$var$LOADING_LABEL)));
});
var $0c35f0f595d2f583$export$2e2bcd8739ae039 = $0c35f0f595d2f583$var$ButtonBase;

});
parcelRegister("2rRcm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c875e7a6748cdf3$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $72NmR = parcelRequire("72NmR");

var $cJhvT = parcelRequire("cJhvT");

var $iSvIT = parcelRequire("iSvIT");


var $iSupW = parcelRequire("iSupW");

var $1OPAa = parcelRequire("1OPAa");

var $fxRez = parcelRequire("fxRez");

var $4OZuI = parcelRequire("4OZuI");

var $7nG8r = parcelRequire("7nG8r");

var $ad8Y3 = parcelRequire("ad8Y3");
var $1c875e7a6748cdf3$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $1c875e7a6748cdf3$var$_excluded2 = [
    "className"
];
var $1c875e7a6748cdf3$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $1c875e7a6748cdf3$var$Pressable = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $4OZuI.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, $cJhvT.default)(_ref, $1c875e7a6748cdf3$var$_excluded);
    var interactionContext = (0, $iSvIT.useContext)((0, $7nG8r.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $1OPAa.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.8.0",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $cJhvT.default)(htmlAttributes, $1c875e7a6748cdf3$var$_excluded2);
    return /*#__PURE__*/ $iSvIT.createElement((0, $ad8Y3.default), (0, $72NmR.default)({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $fxRez.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $iSupW.cx)($1c875e7a6748cdf3$var$styles.root, isDisabled && $1c875e7a6748cdf3$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $1c875e7a6748cdf3$export$2e2bcd8739ae039 = $1c875e7a6748cdf3$var$Pressable;

});
parcelRegister("fxRez", function(module, exports) {

$parcel$export(module.exports, "isSafari", function () { return $b5133b43f7dd91b1$export$95df08bae54cb4df; });
function $b5133b43f7dd91b1$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? //@ts-expect-error ignore userAgentData type issue
    re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $b5133b43f7dd91b1$var$isIPhone() {
    return $b5133b43f7dd91b1$var$testPlatform(/^iPhone/i);
}
function $b5133b43f7dd91b1$var$isMac() {
    return $b5133b43f7dd91b1$var$testPlatform(/^Mac/i);
}
function $b5133b43f7dd91b1$var$isIPad() {
    return $b5133b43f7dd91b1$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    // eslint-disable-next-line compat/compat
    $b5133b43f7dd91b1$var$isMac() && navigator.maxTouchPoints > 1;
}
function $b5133b43f7dd91b1$var$isIOS() {
    return $b5133b43f7dd91b1$var$isIPhone() || $b5133b43f7dd91b1$var$isIPad();
}
function $b5133b43f7dd91b1$export$95df08bae54cb4df() {
    if (typeof window !== "undefined" && window.navigator != null) {
        var _window$navigator$use2;
        var ua = (_window$navigator$use2 = window.navigator.userAgent) === null || _window$navigator$use2 === void 0 ? void 0 : _window$navigator$use2.toLowerCase();
        return ua ? ua.includes("safari") && !ua.includes("chrome") : false;
    }
    return false;
}
function $b5133b43f7dd91b1$export$e1865c3bedcd822b() {
    return $b5133b43f7dd91b1$var$isMac() || $b5133b43f7dd91b1$var$isIOS();
}

});


parcelRegister("2i2fk", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", function () { return $1aaf014670118ed6$export$4b86304b2c0d7e71; });
$parcel$export(module.exports, "useSplitButtonContext", function () { return $1aaf014670118ed6$export$47e2c6fdb142d947; });

var $iSvIT = parcelRequire("iSvIT");
var $1aaf014670118ed6$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $iSvIT.createContext)(undefined);
var $1aaf014670118ed6$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $iSvIT.useContext)($1aaf014670118ed6$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("9lekW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cd132358d836558$export$2e2bcd8739ae039; });
function $6cd132358d836558$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $6cd132358d836558$var$tabKeyCode = 9;
function $6cd132358d836558$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $6cd132358d836558$var$tabKeyCode) return;
    $6cd132358d836558$var$abort(event);
}
function $6cd132358d836558$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $6cd132358d836558$var$abort,
        onMouseUpCapture: $6cd132358d836558$var$abort,
        onKeyDownCapture: $6cd132358d836558$var$onKey,
        onKeyUpCapture: $6cd132358d836558$var$onKey,
        onTouchStartCapture: $6cd132358d836558$var$abort,
        onTouchEndCapture: $6cd132358d836558$var$abort,
        onPointerDownCapture: $6cd132358d836558$var$abort,
        onPointerUpCapture: $6cd132358d836558$var$abort,
        onClickCapture: $6cd132358d836558$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $6cd132358d836558$var$abort
    } : events;
}

});

parcelRegister("5rIkq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f71dc1866f7c5a9$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $efFUG = parcelRequire("efFUG");
function $3f71dc1866f7c5a9$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        default:
            return "medium";
    }
}
function $3f71dc1866f7c5a9$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $3f71dc1866f7c5a9$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $efFUG.default), {
        size: $3f71dc1866f7c5a9$var$getIconSpacing(spacing),
        appearance: $3f71dc1866f7c5a9$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("efFUG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a602fa79da67b6ca$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hfd70 = parcelRequire("hfd70");

var $iSvIT = parcelRequire("iSvIT");

var $7nG8r = parcelRequire("7nG8r");

var $6NCsh = parcelRequire("6NCsh");

var $bvKnA = parcelRequire("bvKnA");
/**
 * Returns the appropriate circle stroke color.
 */ function $a602fa79da67b6ca$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $6NCsh.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $6NCsh.N0), ")");
}
var $a602fa79da67b6ca$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $a602fa79da67b6ca$var$loadIn = null;
var $a602fa79da67b6ca$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $a602fa79da67b6ca$var$useLayoutEffect = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $a602fa79da67b6ca$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $bvKnA.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $a602fa79da67b6ca$var$getStrokeColor(appearance);
    var context = (0, $iSvIT.useContext)((0, $7nG8r.default));
    $a602fa79da67b6ca$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $hfd70.default)([
            $a602fa79da67b6ca$var$styles.wrapperStyles,
            $a602fa79da67b6ca$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $hfd70.default)([
            $a602fa79da67b6ca$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $hfd70.default)([
            $a602fa79da67b6ca$var$styles.circleStyles
        ])
    })));
}));
var $a602fa79da67b6ca$export$2e2bcd8739ae039 = $a602fa79da67b6ca$var$Spinner;

});
parcelRegister("hfd70", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8de022614a8e617$export$2e2bcd8739ae039; });
const $c8de022614a8e617$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $c8de022614a8e617$var$ATOMIC_GROUP_LENGTH = 5;
function $c8de022614a8e617$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $c8de022614a8e617$var$UNDERSCORE_UNICODE ? $c8de022614a8e617$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("6NCsh", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $4f35260efcc26874$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $4f35260efcc26874$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $4f35260efcc26874$export$4b84fd0e2c617bd = "#FFEBE6";
var $4f35260efcc26874$export$b34b069eff244586 = "#FFBDAD";
var $4f35260efcc26874$export$be802dd0d8b57f35 = "#FF8F73";
var $4f35260efcc26874$export$60847d42f9da92a6 = "#FF7452";
var $4f35260efcc26874$export$4a7404f376229999 = "#FF5630";
var $4f35260efcc26874$export$2010d0fb4295b346 = "#DE350B";
var $4f35260efcc26874$export$2837b5a1a71d5c02 = "#BF2600";
var $4f35260efcc26874$export$8d9596b529bbb9cf = "#FFFAE6";
var $4f35260efcc26874$export$41060a744ab0b7ae = "#FFF0B3";
var $4f35260efcc26874$export$1cc05bbbf340e559 = "#FFE380";
var $4f35260efcc26874$export$5aae31392d72caaa = "#FFC400";
var $4f35260efcc26874$export$c6930421db9fa514 = "#FFAB00";
var $4f35260efcc26874$export$59619663aa6500fb = "#FF991F";
var $4f35260efcc26874$export$874739ea9e379ab6 = "#FF8B00";
var $4f35260efcc26874$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $4f35260efcc26874$export$69a3bf21b9686c2b = "#ABF5D1";
var $4f35260efcc26874$export$afbce1382ec95f73 = "#79F2C0";
var $4f35260efcc26874$export$747d86715d4175de = "#57D9A3";
var $4f35260efcc26874$export$940e1f69e873f202 = "#36B37E";
var $4f35260efcc26874$export$a49394138f7b8e85 = "#00875A";
var $4f35260efcc26874$export$6fa04827ac68a4fb = "#006644";
var $4f35260efcc26874$export$226de0355ed012f8 = "#DEEBFF";
var $4f35260efcc26874$export$8c13c2ee36917869 = "#B3D4FF";
var $4f35260efcc26874$export$ecfc1dff386a3e7a = "#4C9AFF";
var $4f35260efcc26874$export$215b7063051591f1 = "#2684FF";
var $4f35260efcc26874$export$e62e8919cca44969 = "#0065FF";
var $4f35260efcc26874$export$b3de0ae08da2ce64 = "#0052CC";
var $4f35260efcc26874$export$a6ee3d71bc067634 = "#0747A6";
var $4f35260efcc26874$export$67f15409e87642a1 = "#669DF1";
var $4f35260efcc26874$export$f0539dbc42dbb067 = "#8FB8F6";
var $4f35260efcc26874$export$363e4475840015bb = "#EAE6FF";
var $4f35260efcc26874$export$4b0a4417ed59760f = "#C0B6F2";
var $4f35260efcc26874$export$6011520a64d9a187 = "#998DD9";
var $4f35260efcc26874$export$a7175d4e9206bc80 = "#8777D9";
var $4f35260efcc26874$export$b48405b95304b5a1 = "#6554C0";
var $4f35260efcc26874$export$c71e4279dd54a18d = "#5243AA";
var $4f35260efcc26874$export$147899de772240ec = "#403294";
var $4f35260efcc26874$export$2cf711fe14c66f06 = "#E6FCFF";
var $4f35260efcc26874$export$7a8f4d33f6f9772c = "#B3F5FF";
var $4f35260efcc26874$export$776c9c497ef08533 = "#79E2F2";
var $4f35260efcc26874$export$69cb3ca10c1e330e = "#00C7E6";
var $4f35260efcc26874$export$9dc1ef0f3f48059b = "#00B8D9";
var $4f35260efcc26874$export$7c835c78b6fcdef8 = "#00A3BF";
var $4f35260efcc26874$export$6036577f95c3877e = "#008DA6";
var $4f35260efcc26874$export$29a4f05edc054374 = "#FFFFFF";
var $4f35260efcc26874$export$e655ef011c4aa1a2 = "#FAFBFC";
var $4f35260efcc26874$export$9fdfb749e33cdf97 = "#F4F5F7";
var $4f35260efcc26874$export$3e51e8f1440314ba = "#EBECF0";
var $4f35260efcc26874$export$1ce2d1575d444ceb = "#DFE1E6";
var $4f35260efcc26874$export$8754fc7e6d8b3000 = "#C1C7D0";
var $4f35260efcc26874$export$c2e91cbeada39b8b = "#B3BAC5";
var $4f35260efcc26874$export$5f71e19f3a7ad9de = "#A5ADBA";
var $4f35260efcc26874$export$eaa8c8a70ac22806 = "#97A0AF";
var $4f35260efcc26874$export$7c87d337fb91a97d = "#8993A4";
var $4f35260efcc26874$export$d6447c357493214f = "#7A869A";
var $4f35260efcc26874$export$f563ee71e9ee74cd = "#6B778C";
var $4f35260efcc26874$export$e2ef2124cf4024b1 = "#5E6C84";
var $4f35260efcc26874$export$eece5f492e429f08 = "#505F79";
var $4f35260efcc26874$export$c39c0fe0f26207ae = "#42526E";
var $4f35260efcc26874$export$7090862dc3038a9f = "#344563";
var $4f35260efcc26874$export$ad0bacf983b7ddaa = "#253858";
var $4f35260efcc26874$export$7d61b15e0da132af = "#172B4D";
var $4f35260efcc26874$export$fbda843f0a27fe96 = "#091E42";
var $4f35260efcc26874$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $4f35260efcc26874$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $4f35260efcc26874$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $4f35260efcc26874$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $4f35260efcc26874$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $4f35260efcc26874$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $4f35260efcc26874$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $4f35260efcc26874$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $4f35260efcc26874$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $4f35260efcc26874$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $4f35260efcc26874$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $4f35260efcc26874$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $4f35260efcc26874$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $4f35260efcc26874$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $4f35260efcc26874$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $4f35260efcc26874$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $4f35260efcc26874$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $4f35260efcc26874$export$2f6319cf7d736c2a = "#E6EDFA";
var $4f35260efcc26874$export$95126bc8884d6634 = "#DCE5F5";
var $4f35260efcc26874$export$8338d8c35d44ff1 = "#CED9EB";
var $4f35260efcc26874$export$5368d76ae4fbbda7 = "#B8C7E0";
var $4f35260efcc26874$export$9f0a771d16ec8d36 = "#ABBBD6";
var $4f35260efcc26874$export$abcf8c38338b4aa5 = "#9FB0CC";
var $4f35260efcc26874$export$97e81faa16a182c7 = "#8C9CB8";
var $4f35260efcc26874$export$bfe21c59123ecf33 = "#7988A3";
var $4f35260efcc26874$export$ee82aa2ea6a1558 = "#67758F";
var $4f35260efcc26874$export$682927c6ed76be02 = "#56637A";
var $4f35260efcc26874$export$91fd9994c5be9757 = "#455166";
var $4f35260efcc26874$export$d281fbfe3cff2df6 = "#3B475C";
var $4f35260efcc26874$export$3902c91d8b98a753 = "#313D52";
var $4f35260efcc26874$export$8e8133c1ba5845b5 = "#283447";
var $4f35260efcc26874$export$33ff357f6620b39 = "#202B3D";
var $4f35260efcc26874$export$633847cf062b69e0 = "#1B2638";
var $4f35260efcc26874$export$9776a6e503bdbf76 = "#121A29";
var $4f35260efcc26874$export$6c813d5160dff5db = "#0E1624";
var $4f35260efcc26874$export$3d4f271a500072a = "#0D1424";
var $4f35260efcc26874$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $4f35260efcc26874$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $4f35260efcc26874$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $4f35260efcc26874$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $4f35260efcc26874$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $4f35260efcc26874$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $4f35260efcc26874$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $4f35260efcc26874$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $4f35260efcc26874$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $4f35260efcc26874$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $4f35260efcc26874$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $4f35260efcc26874$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $4f35260efcc26874$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $4f35260efcc26874$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $4f35260efcc26874$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $4f35260efcc26874$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $4f35260efcc26874$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $4f35260efcc26874$export$d2adc5dedf09fced = "#292A2E";
var $4f35260efcc26874$export$f51762073d2bb381 = "#94C748";
var $4f35260efcc26874$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("bvKnA", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $861690f6931162cb$export$4e9f1640bbe7a1a8; });
var $861690f6931162cb$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});






//# sourceMappingURL=confirmation-page.80f4b751.js.map
